import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import MarketingReveal from './MarketingReveal';
import { POSSIBILITIES_STEPS } from './homeDummyContent';

/**
 * Peerspace “Your something starts somewhere” — lifestyle image + numbered props.
 */
const MarketingPossibilitiesBand = () => {
  return (
    <section className="bg-m-canvas-light px-4 py-20 sm:px-6 sm:py-28">
      <MarketingReveal className="mx-auto grid w-full max-w-6xl gap-12 lg:grid-cols-2 lg:items-center lg:gap-16">
        <div className="relative overflow-hidden rounded-[28px]">
          <img
            src="https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?auto=format&fit=crop&w=1400&q=80"
            alt=""
            className="aspect-[4/5] w-full object-cover sm:aspect-[5/6]"
            loading="lazy"
          />
          <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/55 to-transparent p-6 sm:p-8">
            <p className="text-sm font-medium text-white">Light &amp; airy celebration</p>
            <p className="text-xs text-white/75">Toronto, CA · Dummy listing</p>
          </div>
        </div>

        <div>
          <p className="mb-3 text-[11px] font-medium uppercase tracking-[0.14em] text-m-ink-faint">
            Why VendaList
          </p>
          <h2 className="marketing-section-title mb-4 max-w-lg text-m-ink">
            Your something starts somewhere
          </h2>
          <p className="marketing-body-lg mb-10 max-w-md text-m-ink-muted">
            Whether it’s a backyard birthday or a ballroom wedding, start with the
            vendors who make the night feel inevitable.
          </p>

          <div className="space-y-8">
            {POSSIBILITIES_STEPS.map((step) => (
              <div key={step.number} className="border-t border-m-border-light pt-6">
                <p className="mb-2 text-[11px] font-medium uppercase tracking-[0.14em] text-m-ink-faint">
                  {step.number}
                </p>
                <h3 className="mb-2 text-lg font-medium tracking-tight text-m-ink sm:text-xl">
                  {step.title}
                </h3>
                <p className="marketing-body text-m-ink-muted">{step.description}</p>
              </div>
            ))}
          </div>

          <div className="mt-10">
            <Link to="/how-it-works" className="marketing-btn marketing-btn-ink gap-2">
              See how booking works
              <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </MarketingReveal>
    </section>
  );
};

export default MarketingPossibilitiesBand;
